import { useQuery } from '@apollo/client'
import { gql } from '~/__generated__'
import { TablePageLayout } from '~/layouts/table-page-layout'
import { Button } from '~/ui/button'
import { GraphqlError } from '~/ui/errors'
import { columns } from './columns'
import { DataTable } from './data-table'
import { Calendar } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useCurrentOrganization } from '~/auth/use-current-organization'

export const schedulesQuery = gql(`
  query PlaylistSchedules($first: Int = 20, $after: String, $organizationId: ID) {
    playlistSchedules(first: $first, after: $after, organizationId: $organizationId) {
      edges {
        node {
          id
          startDate
          endDate
          startTime
          endTime
          rrule
          zone {
            id
            name
            location {
              id
              name
              address
              timeZone
            }
          }
          playlist {
            id
            name
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`)

export const SchedulesScreen = () => {
  const navigate = useNavigate()
  const { id: organizationId } = useCurrentOrganization()
  const { data, fetchMore, error } = useQuery(schedulesQuery, {
    variables: { organizationId: organizationId ?? undefined },
    skip: !organizationId,
  })

  const addSchedule = () => {
    navigate('/schedules/new')
  }

  if (error) {
    return <GraphqlError error={error} />
  }

  const schedules = data?.playlistSchedules.edges.map((edge: any) => edge.node) ?? []
  const pageInfo = data?.playlistSchedules.pageInfo

  return (
    <TablePageLayout padding={false}>
      <div className="flex items-center justify-between border-b border-gray-200 bg-white p-3">
        <h1 className="text-2xl">Schedules</h1>
        <Button variant="outline" size="sm" className="cursor-pointer" onClick={addSchedule}>
          <Calendar className="mr-2 h-3.5 w-3.5" />
          <span className="text-sm">Add Schedule</span>
        </Button>
      </div>
      <DataTable columns={columns} data={schedules} />
      {pageInfo && pageInfo.hasNextPage && (
        <>
          <hr className="my-4 border-0 border-b" />
          <div className="flex gap-2">
            <Button
              variant="outline"
              className="disabled:bg-gray-100"
              onClick={() => {
                fetchMore({
                  variables: {
                    after: pageInfo.endCursor,
                  },
                })
              }}
              disabled={!pageInfo.hasNextPage}
            >
              Load more
            </Button>
          </div>
        </>
      )}
    </TablePageLayout>
  )
}
